<template>
    <div class="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-950 via-gray-900/95 to-black px-4">
      
      <div class="bg-gray-900 p-8 rounded-2xl shadow-xl w-full max-w-md space-y-6">
        
        <div class="text-center">
          <h1 class="text-2xl font-bold text-white mb-2">Login</h1>
        </div>
  
        <form @submit.prevent="login" class="space-y-5">
          
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="email">Email</label>
            <input
              v-model="credentials.email"
              type="email"
              id="email"
              placeholder="admin@example.com"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="password">Password</label>
            <input
              v-model="credentials.password"
              type="password"
              id="password"
              placeholder="••••••••"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <primary-button
            type="submit"
            class="w-full flex justify-center"
            :disabled="loading"
          >
            <template v-if="loading">
              <svg class="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              <span>
                Logging in...
              </span>
            </template>
            <template v-else>
              <span>Login</span>
            </template>
          </primary-button>

  
        </form>
  
        <p v-if="error" class="text-red-500 text-sm text-center">{{ error }}</p>
  
      </div>
  
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import PrimaryButton from '@/components/button/PrimaryButton.vue'
  import { useRoute, useRouter } from 'vue-router'
  import api from '@/utils/api'
  import { useToast } from '@/composables/useToast'
  import { updateUserCredentials } from '@/composables/useAuth'

  const { showToast } = useToast()
  const error = ref('')
  const route = useRoute()
  const router = useRouter()

  const loading = ref(false)
  const redirect = route.query.redirect ?? '/'

  const credentials = ref({
    email: '',
    password: ''
  })
  const login = async () => {
    loading.value = true
    error.value = ''
  
    // Basic Validation
    if (!credentials.value.email || !credentials.value.password) {
      showToast('Please fill in all fields.', 'danger')
      return
    }
  
    if (!credentials.value.email.includes('@')) {
      showToast('Please enter a valid email address.', 'danger')
      return
    }

    try {
      const response = await api.post('/login', credentials.value)

      if (response.data.status == 'success')
      {
        updateUserCredentials(response.data.user.name, response.data.token)
        if (redirect.length > 0)
        {
          router.push({
            path: redirect
          })
          showToast('User logged in!', 'success')
          return
        }
      }


    } catch (error)
    {
      console.error(error)
      showToast('Error logging in.', 'danger')
    } finally {
      loading.value = false
    }
  }
  </script>
  